exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".associated-cases table tbody tr:last-child td{border-bottom:0}.associated-cases .case-label{text-align:center;margin:20px 0}.associated-cases .messages{margin-bottom:30px}.associated-cases .live_search{margin-top:15px;margin-bottom:30px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/components/case/associated_cases/AssociatedCases.less
 ** module id = 1070
 ** module chunks = 0
 **/